import { put, takeLatest } from "@redux-saga/core/effects";
import { PayloadAction } from "@reduxjs/toolkit";
import { call } from "redux-saga/effects";
import fetchAPI, { ApiResponse, HttpMethod } from "../../../utils/api";
import { showError, showSuccess } from "../../toaster/store/slice";
import { User } from "../../users/store/slice";
import invitationPageSlice from "./slice";

type AcceptResponse = ApiResponse<{ data: User }>;

function* invitationPageSaga() {
  yield takeLatest(invitationPageSlice.actions.accept, handleAccept);
}

function* handleAccept({ payload: data }: PayloadAction<any>) {
  yield put(invitationPageSlice.actions.setIsLoading(true));

  if (data.token) {
    const result: AcceptResponse = yield call(fetchAPI, "/invitation", {
      method: HttpMethod.PUT,
      body: JSON.stringify(data),
    });

    if (result && result.data) {
      yield put(invitationPageSlice.actions.setInvited());

      yield put(showSuccess("Profile created. Please login."));
    }
  } else {
    yield put(showError("Token missing."));
  }

  yield put(invitationPageSlice.actions.setIsLoading(false));
}

export default invitationPageSaga;
